var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent",attrs:{"id":"badge_details"}},[_c('Modal',{attrs:{"title":_vm.title,"header":false,"footer":false}},[_c('template',{slot:"body"},[_c('bars',{attrs:{"width":"64","height":"64","color":"#007bff"}})],1)],2)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }